import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

export const useCompetitorManagement = (productId) => {
  const [competitors, setCompetitors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getToken } = useAuth();

  const fetchCompetitors = useCallback(async () => {
    if (!productId) return;
    
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/competitors/products/${productId}/competitors`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCompetitors(response.data);
    } catch (error) {
      console.error('خطا در دریافت لیست رقبا:', error);
      if (error.response?.status === 404) {
        setCompetitors([]);
      } else {
        toast.error('خطا در دریافت لیست رقبا. لطفاً دوباره تلاش کنید.');
      }
    } finally {
      setIsLoading(false);
    }
  }, [getToken, productId]);

  const addCompetitorLink = useCallback(async (link) => {
    try {
      const token = getToken();
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/competitors/add-competitor-link`,
        { url: link, product_id: productId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      await fetchCompetitors();
      toast.success('رقیب با موفقیت اضافه شد');
    } catch (error) {
      console.error('خطا در افزودن رقیب:', error);
      toast.error(error.response?.data?.detail || 'خطا در افزودن رقیب');
    }
  }, [productId, getToken, fetchCompetitors]);

  const removeCompetitor = useCallback(async (competitorId) => {
    try {
      const token = getToken();
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/competitors/products/${productId}/competitors/${competitorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      await fetchCompetitors();
      toast.success('رقیب با موفقیت حذف شد');
    } catch (error) {
      console.error('خطا در حذف رقیب:', error);
      toast.error('خطا در حذف رقیب');
    }
  }, [productId, getToken, fetchCompetitors]);

  useEffect(() => {
    fetchCompetitors();
  }, [fetchCompetitors]);

  return {
    competitors,
    isLoading,
    addCompetitorLink,
    removeCompetitor,
    fetchCompetitors
  };
};
